let navigateMiddlewareFn: (to: string) => void;

export const setNavigateMiddleware = (navFn: typeof navigateMiddlewareFn) => {
  navigateMiddlewareFn = navFn;
};

export const navigateMiddleware = (to: string) => {
  if (navigateMiddlewareFn) navigateMiddlewareFn(to);
};
